import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';
import t from '../../utils/renewalsTranslations';

export default function RecommendationHistory() {
  const { id: policyId } = useParams();
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>{t('renewals.history.title')}</Typography>
      <Typography color="text.secondary">{t('renewals.history.noHistory')}</Typography>
      <Button sx={{ mt: 2 }} onClick={() => navigate(`/renewals/${policyId}`)}>Back to renewal</Button>
    </Container>
  );
}
